<script>
import DashboardLayout from "@/Layouts/DashboardLayout.vue";

export default {
    layout: DashboardLayout,
};
</script>

<script setup>
import { computed } from "vue";
import { Head, usePage } from "@inertiajs/vue3";
import FriendsGrid from "@/Components/Profile/FriendsGrid.vue";
import FriendsHero from "@/Components/Friends/FriendsHero.vue";
import FriendsNav from "@/Components/Friends/FriendsNav.vue";

const followers = computed(() => usePage().props.followers?.data ?? []);
</script>

<template>
    <div>
        <Head>
            <title>Followers | Gift Hero</title>
        </Head>

        <FriendsHero
            title="Followers"
            subtitle="Gift Heroes who follow your wish lists."
        />

        <div class="md:grid md:grid-cols-[352px_1fr] md:gap-16">
            <!-- Desktop sidebar overlaps the hero band; mobile renders tabs -->
            <div class="md:-mt-[137px]">
                <FriendsNav />
            </div>

            <div class="mt-6 min-w-0 md:mt-[61px]">
                <FriendsGrid
                    :people="followers"
                    title="My Followers"
                    empty-message="You don’t have any followers yet. Share your lists to get the word out!"
                />
            </div>
        </div>
    </div>
</template>
